// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets//fonts/Coiny-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Coiny-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/imgs/partly-cloudy-day-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Coiny';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

:root {
  --system-ui:
    system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  --font-color-main: #fff;
  --font-color-secondary: #d8e9f3;
  --font-color-main-dimmer: #ececec;
  --font-color-card-title: #c6e4f5;
  --placeholder-color: #f3f3f3;
  --drop-shadow: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.75));
  --drop-shadow-smooth: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.5));
  --drop-shadow-smoother: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.25));
  --button-selected-color: #ccdfeb;
  --card-bg-color: rgba(93, 101, 105, 0.35);
}

body {
  min-height: 100vh;
  background-color: #333;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  font-family: var(--system-ui);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: var(--font-color-main);
}

.card {
  background-color: var(--card-bg-color);
  backdrop-filter: blur(8px);
  border-radius: 16px;

  ::-webkit-scrollbar {
    height: 12px;
  }

  ::-webkit-scrollbar-track {
    background-color: rgba(200, 205, 210, 0.3);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(200, 205, 210);
  }

  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
  }
}

.icon,
button {
  user-select: none;
}

button {
  cursor: pointer;
}

[text-wrap='off'] {
  text-wrap: nowrap;
}

[overflow='ellipsis'] {
  overflow: hidden;
  text-overflow: ellipsis;
}

#main-title {
  font-size: 3rem;
  font-weight: 600;
  padding: 16px 32px;
  border-radius: 8px;
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
  filter: var(--drop-shadow-smoother);

  display: flex;
  justify-content: center;
  gap: 12px;

  .logo {
    width: 4.25rem;
  }

  .text {
    font-family: 'Coiny', var(--system-ui);
    font-weight: 100;
  }
}

.container {
  max-width: 1300px;
}

#header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  padding: 16px;
}

#location-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  filter: var(--drop-shadow);
  justify-self: start;

  .current-location {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 1.2rem;
    line-height: 1.2rem;
    font-weight: 600;
    max-width: 32ch;
    text-transform: capitalize;
  }

  #query-form {
    display: flex;
    align-items: center;

    input {
      border: none;
      background-color: transparent;
      border-bottom: 2px solid white;
      outline: none;
      color: inherit;

      &::placeholder {
        color: var(--placeholder-color);
      }
    }

    button {
      outline: none;
      border: none;
      background-color: transparent;
    }

    .loading {
      margin-left: 10px;
      font-weight: 500;
    }
  }

  .error {
    color: #fff;
    max-width: 380px;
  }
}

#main-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  text-align: center;
  justify-self: center;
  filter: var(--drop-shadow-smooth);

  .wrapper {
    display: flex;
    align-items: center;
    gap: 16px;

    .icon {
      width: 5rem;
    }

    .temperature {
      font-size: 5rem;
    }
  }

  .feels-like {
    color: var(--font-color-secondary);
  }

  .conditions {
    max-width: 32ch;
    text-transform: capitalize;
  }
}

#settings {
  justify-self: end;
  display: flex;
  flex-direction: column;
  gap: 16px;
  filter: var(--drop-shadow-smoother);

  .setting {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.9rem;

    .label {
      font-weight: 500;
    }

    .options {
      display: flex;
      gap: 12px;

      button {
        outline: 2px solid transparent;
        border-radius: 4px;
        border: none;
        width: 10ch;
        color: #333;

        &[selected] {
          background-color: var(--button-selected-color);
        }

        &:hover {
          outline-color: #9ab1c4;
        }
      }
    }
  }
}

.cards-section {
  flex: 1;
  display: grid;
  margin-top: 32px;
  grid-template-columns: 1fr 180px 180px 1fr;
  grid-template-rows: 1fr 180px 180px;
  gap: 24px;

  .card {
    display: flex;
    flex-direction: column;
    padding: 16px;

    .title {
      text-transform: uppercase;
      font-weight: 600;
      color: var(--font-color-card-title);
      border-bottom: 1px solid #c6d9e27e;
      padding-bottom: 4px;
    }
  }
}

#hourly-forecast {
  grid-column: 1 / -2;
  grid-row-start: 1;
  padding-bottom: 24px;

  .title {
    margin-bottom: 32px;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    padding: 8px 16px;

    .today-info {
      .subtitle {
        font-size: 1.15rem;
        font-weight: 600;
        margin-bottom: 8px;
      }

      .min-max {
        margin-bottom: 16px;
      }

      .value,
      .temperature-unit {
        font-weight: 600;
      }
    }

    .hours {
      display: grid;
      grid-auto-flow: column;
      grid-template-rows: 1fr 2fr 2fr 1fr;
      grid-auto-columns: 50px;
      align-items: center;
      justify-items: center;
      gap: 0px 24px;
      overflow-x: scroll;
      font-size: 0.9rem;
      padding-bottom: 8px;

      .time {
        font-weight: 500;
      }

      .wrapper {
        display: flex;
        color: var(--font-color-secondary);
        font-size: 0.8rem;
      }

      .icon {
        width: 35px;
      }
    }
  }
}

#day-forecast {
  grid-row: 1 / -1;
  grid-column-start: -2;

  .title {
    margin-bottom: 32px;
  }

  .content {
    display: grid;
    grid-template-columns: 2fr 1fr 2fr 2fr;
    grid-auto-rows: minmax(3rem, auto);
    gap: 8px;
    justify-items: center;
    align-items: center;

    .description {
      grid-row-start: 1;
      grid-column: 1 / -1;
      font-size: 0.95rem;
      padding: 0 32px;
    }

    .icon {
      width: 35px;
    }

    .value,
    .temperature-unit {
      font-weight: 600;
    }
  }
}

#precipitation {
  grid-column-start: 1;
  grid-row-start: 2;

  .content {
    display: grid;
    height: 100%;
    grid-template-columns: 1fr 1.25fr 1.25fr;
    gap: 8px;
    align-items: center;
    justify-items: center;
    padding: 8px;
    font-size: 1.5rem;

    .icon {
      width: 70px;
    }

    .precip-level,
    .precip-prob {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .value {
      font-size: 2.25rem;
      font-weight: 600;
    }

    .feedback {
      color: var(--font-color-secondary);
      font-size: 1rem;
    }
  }
}

#wind {
  grid-column-start: 1;
  grid-row-start: 3;

  .content {
    display: flex;
    align-items: center;
    padding: 16px 32px;
    height: 100%;
    gap: 64px;
    font-size: 1rem;

    .wrapper {
      display: grid;
      grid-template-rows: 1fr 1fr 1fr;
      align-items: center;
      gap: 4px;
    }

    .value {
      font-size: 1.25rem;
    }

    .feedback {
      color: var(--font-color-secondary);
    }
  }

  .compass {
    border: 2px dashed #fff;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .north {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: sans-serif;
      font-size: 13px;
      line-height: 0;
      background-color: #fff;
      color: #7c7c7c;
      font-weight: 600;
      padding: 10px;
      position: absolute;
      border-radius: 50%;
      border: 1px solid white;
      left: 38%;
      top: -8px;
      width: 2ch;
      height: 2ch;
    }

    #arrow-icon {
      transform: rotate(0deg);
      width: 40px;
    }
  }
}

#humidity,
#pressure,
#sunrise-sunset,
#uv-index {
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
}

#sunrise-sunset {
  grid-column-start: 2;
  grid-row-start: 2;

  .content {
    gap: 8px;
    padding: 16px;

    .label {
      font-size: 0.9rem;
    }

    .value {
      font-size: 1.15rem;
      font-weight: 600;
    }
  }
}

#humidity {
  grid-column-start: 3;
  grid-row-start: 2;

  .content {
    align-items: center;

    .air-humidity {
      font-size: 1.5rem;
      .value {
        font-size: 2.5rem;
        font-weight: 600;
      }
    }

    .feedback {
      color: var(--font-color-secondary);
    }
  }
}

#pressure {
  grid-column-start: 2;
  grid-row-start: 3;

  .content {
    align-items: center;

    .air-pressure {
      font-size: 1.2rem;
      .value {
        font-size: 2rem;
        font-weight: 600;
      }
    }

    .feedback {
      color: var(--font-color-secondary);
    }
  }
}

#uv-index {
  grid-column-start: 3;
  grid-row-start: 3;

  .content {
    align-items: center;

    .value {
      font-size: 2rem;
      font-weight: 600;
    }

    .feedback {
      color: var(--font-color-secondary);
    }

    .meter {
      border-radius: 8px;
      width: calc(calc(11 * 10px) + 4px);
      background-color: #fff;
      height: 10px;
      padding: 2px;
      margin-top: 8px;

      .bar {
        border-radius: inherit;
        height: 100%;
        width: 0%;
        background-color: #fff;
      }
    }
  }
}

.footer {
  padding: 2px 0;
  margin: 20px 0 4px 0;
  filter: var(--drop-shadow);

  a {
    text-decoration: none;
    color: inherit;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB;;0DAE0D;EAC1D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;;2DAEyD;EACzD,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;EAC5B,2DAA2D;EAC3D,iEAAiE;EACjE,oEAAoE;EACpE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yDAAwE;EACxE,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,mBAAmB;;EAEnB;IACE,YAAY;EACd;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;;EAEnC,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET;IACE,cAAc;EAChB;;EAEA;IACE,sCAAsC;IACtC,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;;EAEnB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB;MACE,YAAY;MACZ,6BAA6B;MAC7B,8BAA8B;MAC9B,aAAa;MACb,cAAc;;MAEd;QACE,+BAA+B;MACjC;IACF;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,6BAA6B;IAC/B;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;IAClB;EACF;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;;EAEjC;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mCAAmC;;EAEnC;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;;IAEjB;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,SAAS;;MAET;QACE,8BAA8B;QAC9B,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,WAAW;;QAEX;UACE,8CAA8C;QAChD;;QAEA;UACE,sBAAsB;QACxB;MACF;IACF;EACF;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,mCAAmC;EACnC,SAAS;;EAET;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;;IAEb;MACE,yBAAyB;MACzB,gBAAgB;MAChB,mCAAmC;MACnC,kCAAkC;MAClC,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;;EAEpB;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;;IAEjB;MACE;QACE,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;MACpB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;;QAEE,gBAAgB;MAClB;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mCAAmC;MACnC,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;MACrB,aAAa;MACb,kBAAkB;MAClB,iBAAiB;MACjB,mBAAmB;;MAEnB;QACE,gBAAgB;MAClB;;MAEA;QACE,aAAa;QACb,kCAAkC;QAClC,iBAAiB;MACnB;;MAEA;QACE,WAAW;MACb;IACF;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;;EAErB;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,kCAAkC;IAClC,QAAQ;IACR,qBAAqB;IACrB,mBAAmB;;IAEnB;MACE,iBAAiB;MACjB,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,WAAW;IACb;;IAEA;;MAEE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;;EAEjB;IACE,aAAa;IACb,YAAY;IACZ,wCAAwC;IACxC,QAAQ;IACR,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;;IAEjB;MACE,WAAW;IACb;;IAEA;;MAEE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,kCAAkC;MAClC,eAAe;IACjB;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;;EAEjB;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,eAAe;;IAEf;MACE,aAAa;MACb,+BAA+B;MAC/B,mBAAmB;MACnB,QAAQ;IACV;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kCAAkC;IACpC;EACF;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,uBAAuB;MACvB,eAAe;MACf,cAAc;MACd,sBAAsB;MACtB,cAAc;MACd,gBAAgB;MAChB,aAAa;MACb,kBAAkB;MAClB,kBAAkB;MAClB,uBAAuB;MACvB,SAAS;MACT,SAAS;MACT,UAAU;MACV,WAAW;IACb;;IAEA;MACE,uBAAuB;MACvB,WAAW;IACb;EACF;AACF;;AAEA;;;;EAIE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;;EAEjB;IACE,QAAQ;IACR,aAAa;;IAEb;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;;EAEjB;IACE,mBAAmB;;IAEnB;MACE,iBAAiB;MACjB;QACE,iBAAiB;QACjB,gBAAgB;MAClB;IACF;;IAEA;MACE,kCAAkC;IACpC;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;;EAEjB;IACE,mBAAmB;;IAEnB;MACE,iBAAiB;MACjB;QACE,eAAe;QACf,gBAAgB;MAClB;IACF;;IAEA;MACE,kCAAkC;IACpC;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;;EAEjB;IACE,mBAAmB;;IAEnB;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,kCAAkC;IACpC;;IAEA;MACE,kBAAkB;MAClB,kCAAkC;MAClC,sBAAsB;MACtB,YAAY;MACZ,YAAY;MACZ,eAAe;;MAEf;QACE,sBAAsB;QACtB,YAAY;QACZ,SAAS;QACT,sBAAsB;MACxB;IACF;EACF;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,0BAA0B;;EAE1B;IACE,qBAAqB;IACrB,cAAc;EAChB;AACF","sourcesContent":["@font-face {\n  font-family: 'Coiny';\n  src:\n    url('../assets//fonts/Coiny-Regular.woff2') format('woff2'),\n    url('../assets/fonts/Coiny-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n:root {\n  --system-ui:\n    system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',\n    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  --font-color-main: #fff;\n  --font-color-secondary: #d8e9f3;\n  --font-color-main-dimmer: #ececec;\n  --font-color-card-title: #c6e4f5;\n  --placeholder-color: #f3f3f3;\n  --drop-shadow: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.75));\n  --drop-shadow-smooth: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.5));\n  --drop-shadow-smoother: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.25));\n  --button-selected-color: #ccdfeb;\n  --card-bg-color: rgba(93, 101, 105, 0.35);\n}\n\nbody {\n  min-height: 100vh;\n  background-color: #333;\n  background-image: url('../assets/imgs/partly-cloudy-day-background.jpg');\n  background-size: cover;\n  font-family: var(--system-ui);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  color: var(--font-color-main);\n}\n\n.card {\n  background-color: var(--card-bg-color);\n  backdrop-filter: blur(8px);\n  border-radius: 16px;\n\n  ::-webkit-scrollbar {\n    height: 12px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: rgba(200, 205, 210, 0.3);\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: rgb(200, 205, 210);\n  }\n\n  ::-webkit-scrollbar-track,\n  ::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n  }\n}\n\n.icon,\nbutton {\n  user-select: none;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n[text-wrap='off'] {\n  text-wrap: nowrap;\n}\n\n[overflow='ellipsis'] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#main-title {\n  font-size: 3rem;\n  font-weight: 600;\n  padding: 16px 32px;\n  border-radius: 8px;\n  width: 100%;\n  text-align: center;\n  margin: 10px 0 20px 0;\n  filter: var(--drop-shadow-smoother);\n\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n\n  .logo {\n    width: 4.25rem;\n  }\n\n  .text {\n    font-family: 'Coiny', var(--system-ui);\n    font-weight: 100;\n  }\n}\n\n.container {\n  max-width: 1300px;\n}\n\n#header {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n  padding: 16px;\n}\n\n#location-info {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  filter: var(--drop-shadow);\n  justify-self: start;\n\n  .current-location {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 1.2rem;\n    line-height: 1.2rem;\n    font-weight: 600;\n    max-width: 32ch;\n    text-transform: capitalize;\n  }\n\n  #query-form {\n    display: flex;\n    align-items: center;\n\n    input {\n      border: none;\n      background-color: transparent;\n      border-bottom: 2px solid white;\n      outline: none;\n      color: inherit;\n\n      &::placeholder {\n        color: var(--placeholder-color);\n      }\n    }\n\n    button {\n      outline: none;\n      border: none;\n      background-color: transparent;\n    }\n\n    .loading {\n      margin-left: 10px;\n      font-weight: 500;\n    }\n  }\n\n  .error {\n    color: #fff;\n    max-width: 380px;\n  }\n}\n\n#main-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  text-align: center;\n  justify-self: center;\n  filter: var(--drop-shadow-smooth);\n\n  .wrapper {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    .icon {\n      width: 5rem;\n    }\n\n    .temperature {\n      font-size: 5rem;\n    }\n  }\n\n  .feels-like {\n    color: var(--font-color-secondary);\n  }\n\n  .conditions {\n    max-width: 32ch;\n    text-transform: capitalize;\n  }\n}\n\n#settings {\n  justify-self: end;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  filter: var(--drop-shadow-smoother);\n\n  .setting {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 0.9rem;\n\n    .label {\n      font-weight: 500;\n    }\n\n    .options {\n      display: flex;\n      gap: 12px;\n\n      button {\n        outline: 2px solid transparent;\n        border-radius: 4px;\n        border: none;\n        width: 10ch;\n        color: #333;\n\n        &[selected] {\n          background-color: var(--button-selected-color);\n        }\n\n        &:hover {\n          outline-color: #9ab1c4;\n        }\n      }\n    }\n  }\n}\n\n.cards-section {\n  flex: 1;\n  display: grid;\n  margin-top: 32px;\n  grid-template-columns: 1fr 180px 180px 1fr;\n  grid-template-rows: 1fr 180px 180px;\n  gap: 24px;\n\n  .card {\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n\n    .title {\n      text-transform: uppercase;\n      font-weight: 600;\n      color: var(--font-color-card-title);\n      border-bottom: 1px solid #c6d9e27e;\n      padding-bottom: 4px;\n    }\n  }\n}\n\n#hourly-forecast {\n  grid-column: 1 / -2;\n  grid-row-start: 1;\n  padding-bottom: 24px;\n\n  .title {\n    margin-bottom: 32px;\n  }\n\n  .content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    height: 100%;\n    padding: 8px 16px;\n\n    .today-info {\n      .subtitle {\n        font-size: 1.15rem;\n        font-weight: 600;\n        margin-bottom: 8px;\n      }\n\n      .min-max {\n        margin-bottom: 16px;\n      }\n\n      .value,\n      .temperature-unit {\n        font-weight: 600;\n      }\n    }\n\n    .hours {\n      display: grid;\n      grid-auto-flow: column;\n      grid-template-rows: 1fr 2fr 2fr 1fr;\n      grid-auto-columns: 50px;\n      align-items: center;\n      justify-items: center;\n      gap: 0px 24px;\n      overflow-x: scroll;\n      font-size: 0.9rem;\n      padding-bottom: 8px;\n\n      .time {\n        font-weight: 500;\n      }\n\n      .wrapper {\n        display: flex;\n        color: var(--font-color-secondary);\n        font-size: 0.8rem;\n      }\n\n      .icon {\n        width: 35px;\n      }\n    }\n  }\n}\n\n#day-forecast {\n  grid-row: 1 / -1;\n  grid-column-start: -2;\n\n  .title {\n    margin-bottom: 32px;\n  }\n\n  .content {\n    display: grid;\n    grid-template-columns: 2fr 1fr 2fr 2fr;\n    grid-auto-rows: minmax(3rem, auto);\n    gap: 8px;\n    justify-items: center;\n    align-items: center;\n\n    .description {\n      grid-row-start: 1;\n      grid-column: 1 / -1;\n      font-size: 0.95rem;\n      padding: 0 32px;\n    }\n\n    .icon {\n      width: 35px;\n    }\n\n    .value,\n    .temperature-unit {\n      font-weight: 600;\n    }\n  }\n}\n\n#precipitation {\n  grid-column-start: 1;\n  grid-row-start: 2;\n\n  .content {\n    display: grid;\n    height: 100%;\n    grid-template-columns: 1fr 1.25fr 1.25fr;\n    gap: 8px;\n    align-items: center;\n    justify-items: center;\n    padding: 8px;\n    font-size: 1.5rem;\n\n    .icon {\n      width: 70px;\n    }\n\n    .precip-level,\n    .precip-prob {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    .value {\n      font-size: 2.25rem;\n      font-weight: 600;\n    }\n\n    .feedback {\n      color: var(--font-color-secondary);\n      font-size: 1rem;\n    }\n  }\n}\n\n#wind {\n  grid-column-start: 1;\n  grid-row-start: 3;\n\n  .content {\n    display: flex;\n    align-items: center;\n    padding: 16px 32px;\n    height: 100%;\n    gap: 64px;\n    font-size: 1rem;\n\n    .wrapper {\n      display: grid;\n      grid-template-rows: 1fr 1fr 1fr;\n      align-items: center;\n      gap: 4px;\n    }\n\n    .value {\n      font-size: 1.25rem;\n    }\n\n    .feedback {\n      color: var(--font-color-secondary);\n    }\n  }\n\n  .compass {\n    border: 2px dashed #fff;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .north {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-family: sans-serif;\n      font-size: 13px;\n      line-height: 0;\n      background-color: #fff;\n      color: #7c7c7c;\n      font-weight: 600;\n      padding: 10px;\n      position: absolute;\n      border-radius: 50%;\n      border: 1px solid white;\n      left: 38%;\n      top: -8px;\n      width: 2ch;\n      height: 2ch;\n    }\n\n    #arrow-icon {\n      transform: rotate(0deg);\n      width: 40px;\n    }\n  }\n}\n\n#humidity,\n#pressure,\n#sunrise-sunset,\n#uv-index {\n  .content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n  }\n}\n\n#sunrise-sunset {\n  grid-column-start: 2;\n  grid-row-start: 2;\n\n  .content {\n    gap: 8px;\n    padding: 16px;\n\n    .label {\n      font-size: 0.9rem;\n    }\n\n    .value {\n      font-size: 1.15rem;\n      font-weight: 600;\n    }\n  }\n}\n\n#humidity {\n  grid-column-start: 3;\n  grid-row-start: 2;\n\n  .content {\n    align-items: center;\n\n    .air-humidity {\n      font-size: 1.5rem;\n      .value {\n        font-size: 2.5rem;\n        font-weight: 600;\n      }\n    }\n\n    .feedback {\n      color: var(--font-color-secondary);\n    }\n  }\n}\n\n#pressure {\n  grid-column-start: 2;\n  grid-row-start: 3;\n\n  .content {\n    align-items: center;\n\n    .air-pressure {\n      font-size: 1.2rem;\n      .value {\n        font-size: 2rem;\n        font-weight: 600;\n      }\n    }\n\n    .feedback {\n      color: var(--font-color-secondary);\n    }\n  }\n}\n\n#uv-index {\n  grid-column-start: 3;\n  grid-row-start: 3;\n\n  .content {\n    align-items: center;\n\n    .value {\n      font-size: 2rem;\n      font-weight: 600;\n    }\n\n    .feedback {\n      color: var(--font-color-secondary);\n    }\n\n    .meter {\n      border-radius: 8px;\n      width: calc(calc(11 * 10px) + 4px);\n      background-color: #fff;\n      height: 10px;\n      padding: 2px;\n      margin-top: 8px;\n\n      .bar {\n        border-radius: inherit;\n        height: 100%;\n        width: 0%;\n        background-color: #fff;\n      }\n    }\n  }\n}\n\n.footer {\n  padding: 2px 0;\n  margin: 20px 0 4px 0;\n  filter: var(--drop-shadow);\n\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
